/* eslint-disable @typescript-eslint/no-explicit-any */
import { Loading3QuartersOutlined } from "@ant-design/icons";
import { Button, Col, Form, Row, Spin } from "antd";

import { DateField } from "../../../../atoms/FormFields";
import { useForm } from "react-hook-form";
import { useEffect } from "react";
import dayjs from "dayjs";
import { moveScheduleToDate } from "../../ducks/services";
import { SuccessMessage } from "../../../../atoms/Toasts/SuccessMessage";
import { useAppDispatch } from "../../../../config/hooks";
import { getSchedulingFormData } from "../../ducks/actions";
import { AxiosError } from "axios";
import { ErrorMessage } from "../../../../atoms/Toasts/ErrorMessage";

const antIcon = <Loading3QuartersOutlined spin />;

interface PropsType {
  onClose: () => void;
  loading: boolean;
  selectedDate: string; // Optional prop for selected date
  scheduleId?: string; // Optional prop for selected date
  weekStartDate?: dayjs.Dayjs | null;
  setLoading: (loading: boolean) => void;
}

const MoveCrewScheduleBy = (props: PropsType) => {
  const {
    onClose,
    loading,
    selectedDate,
    scheduleId,
    weekStartDate,
    setLoading,
  } = props;
  const onCloseHandler = () => {
    onClose();
  };

  const {
    control,
    handleSubmit,
    setValue,
    watch,
    formState: { errors },
  } = useForm();
  const dispatch = useAppDispatch();
  const onSubmit = (val: any) => {
    console.log(val);

    const payload = {
      schedule_id: scheduleId,
      date: dayjs(val?.shift_to).format("YYYY-MM-DD"),
    };
    moveScheduleToDate(payload)
      .then(() => {
        const payload = {
          date: dayjs(weekStartDate).format("YYYY-MM-DD"),
        };
        dispatch(getSchedulingFormData(payload));
        onClose();
        SuccessMessage("Scheduled moved");
        setLoading(false);
      })
      .catch((e: unknown) => {
        if (e instanceof AxiosError) {
          ErrorMessage(
            e?.response?.data?.error?.message ?? "Something went wrong"
          );
          setLoading(false);
        } else {
          ErrorMessage("Something went wrong");
          setLoading(false);
        }
      });
  };

  useEffect(() => {
    if (selectedDate) {
      setValue("shift_from", dayjs(selectedDate));
    }
  }, [selectedDate, setValue]);

  const shiftTo = watch("shift_to");
  const difference = dayjs(shiftTo).diff(dayjs(selectedDate), "day");

  console.log("difference", selectedDate, shiftTo);

  return (
    <Spin indicator={antIcon} size="large" spinning={loading}>
      <div className="modalWrapper scheduleWrapper">
        <div className="modal_header">
          <div className="title">
            <h3> Shift crew's schedule </h3>
            <p style={{ color: "#151718" }}>
              All scheduled days starting from the <b>Shift from</b> date will
              be moved to start on the <b>Shift to</b> date.
            </p>
          </div>
        </div>
        <Form
          layout="vertical"
          onFinish={handleSubmit(onSubmit)}
          onKeyDown={(e) => {
            if (e.key === "Enter") e.preventDefault();
          }}
        >
          <div className="modal_content">
            <Row gutter={16}>
              <Col span={12}>
                <DateField
                  fieldName="shift_from"
                  label="Shift from"
                  control={control}
                  tooltipTitle="Shift from"
                  isRequired
                  rules={{
                    required: "Shift from is required.",
                  }}
                  validate={errors.shift_from && "error"}
                  validMessage={errors.shift_from && errors.shift_from.message}
                  iProps={{ disabled: true }}
                />
              </Col>
              <Col span={12}>
                <DateField
                  fieldName="shift_to"
                  label="Shift to"
                  control={control}
                  tooltipTitle="Shift to"
                  isRequired
                  rules={{
                    required: "Shift to is required.",
                  }}
                  validate={errors.shift_to && "error"}
                  validMessage={errors.shift_to && errors.shift_to.message}
                  // iProps={{ disabled: }}
                />
              </Col>
              {difference > 0 && (
                <Col span={24}>
                  <p
                    style={{
                      color: "#6C7478",
                      fontSize: "12px",
                      marginTop: "-8px",
                    }}
                  >
                    All visits from {dayjs(selectedDate).format("MMM D")} will
                    move{" "}
                    <span style={{ color: "#6454F4", fontWeight: "600" }}>
                      {difference + 1} working days later
                    </span>
                    . Days off excluded.
                  </p>
                </Col>
              )}
            </Row>
          </div>
          <div className="modal_footer">
            <Button
              htmlType="button"
              className="outlined-btn"
              type="default"
              size="large"
              onClick={onCloseHandler}
            >
              Cancel
            </Button>

            <Button
              htmlType="submit"
              className="mint-btn"
              type="primary"
              size="large"
              loading={loading}
            >
              Shift schedule
            </Button>
          </div>
        </Form>
      </div>
    </Spin>
  );
};

export default MoveCrewScheduleBy;
